import type { SegmentToolBinding } from "./segmentTool";
import { bindSegmentTool } from "./segmentTool";
import type { SceneHost } from "../SceneHost";

export function bindLineTool(host: SceneHost): SegmentToolBinding {
  return bindSegmentTool(host, "line");
}

export function bindArrowTool(host: SceneHost): SegmentToolBinding {
  return bindSegmentTool(host, "arrow");
}
